const MAdmin = [
  {
    title: 'Overall',
    is_heading: true,
    is_active: false,
    link: {
      name: 'shared.dashboard'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-objects-column',
    active_icon: 'fad fa-objects-column'
  },
  {
    title: 'Dashboard',
    is_heading: false,
    is_active: false,
    link: {
      name: 'shared.dashboard'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-objects-column',
    active_icon: 'fad fa-objects-column'
  },
  {
    title: 'Management',
    is_heading: true,
    is_active: false,
    link: {
      name: 'shared.dashboard'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-cog',
    active_icon: 'fad fa-cog'
  },
  {
    title: 'User Management',
    is_heading: false,
    is_active: false,
    link: {
      name: 'admin.users'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-users',
    active_icon: 'fad fa-users'
  },
  {
    title: 'Students',
    is_heading: false,
    is_active: false,
    link: {
      name: 'admin.students'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-user-graduate',
    active_icon: 'fad fa-user-graduate'
  },
  {
    title: 'Student Residences',
    is_heading: false,
    is_active: false,
    link: {
      name: 'admin.student-residences'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-house-user',
    active_icon: 'fad fa-house-user'
  },
  {
    title: 'Violations',
    is_heading: false,
    is_active: false,
    link: {
      name: 'admin.violations'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-exclamation-triangle',
    active_icon: 'fad fa-exclamation-triangle'
  },
  {
    title: 'Operations',
    is_heading: true,
    is_active: false,
    link: {
      name: 'shared.dashboard'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-clipboard-list',
    active_icon: 'fad fa-clipboard-list'
  },
  {
    title: 'Appointments',
    is_heading: false,
    is_active: false,
    link: {
      name: 'admin.appointments'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-calendar-check',
    active_icon: 'fad fa-calendar-check'
  },
  {
    title: 'Lost & Found',
    is_heading: false,
    is_active: false,
    link: {
      name: 'admin.lost-and-found'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-search-location',
    active_icon: 'fad fa-search-location'
  },
  {
    title: 'Complaints',
    is_heading: false,
    is_active: false,
    link: {
      name: 'admin.complaints'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-comment-exclamation',
    active_icon: 'fad fa-comment-exclamation'
  },
  {
    title: 'Counseling Chat',
    is_heading: false,
    is_active: false,
    link: {
      name: 'admin.counseling-chat'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-comments',
    active_icon: 'fad fa-comments'
  },
  {
    title: 'Feedback',
    is_heading: false,
    is_active: false,
    link: {
      name: 'admin.feedback'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-star',
    active_icon: 'fad fa-star'
  },
  {
    title: 'Configuration',
    is_heading: true,
    is_active: false,
    link: {
      name: 'shared.dashboard'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-cogs',
    active_icon: 'fad fa-cogs'
  },
  {
    title: 'Violation Types',
    is_heading: false,
    is_active: false,
    link: {
      name: 'admin.violation-types'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-list-alt',
    active_icon: 'fad fa-list-alt'
  },
  {
    title: 'Appointment Slots',
    is_heading: false,
    is_active: false,
    link: {
      name: 'admin.appointment-slots'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-calendar-alt',
    active_icon: 'fad fa-calendar-alt'
  },
  {
    title: 'Concern Types',
    is_heading: false,
    is_active: false,
    link: {
      name: 'admin.appointment-concern-types'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-tags',
    active_icon: 'fad fa-tags'
  },
  {
    title: 'Appointment Notifications',
    is_heading: false,
    is_active: false,
    link: {
      name: 'admin.appointment-notification-settings'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-envelope-open-text',
    active_icon: 'fad fa-envelope-open-text'
  },
  {
    title: 'L&F Categories',
    is_heading: false,
    is_active: false,
    link: {
      name: 'admin.lf-item-categories'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-th-list',
    active_icon: 'fad fa-th-list'
  },
  {
    title: 'Resource Categories',
    is_heading: false,
    is_active: false,
    link: {
      name: 'admin.resource-categories'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-layer-group',
    active_icon: 'fad fa-layer-group'
  },
  {
    title: 'Resources',
    is_heading: false,
    is_active: false,
    link: {
      name: 'admin.resources'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-folder-open',
    active_icon: 'fad fa-folder-open'
  },
  {
    title: 'Announcements',
    is_heading: false,
    is_active: false,
    link: {
      name: 'admin.announcements'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-bullhorn',
    active_icon: 'fad fa-bullhorn'
  },
  {
    title: 'Events',
    is_heading: false,
    is_active: false,
    link: {
      name: 'admin.events'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-calendar-star',
    active_icon: 'fad fa-calendar-star'
  },
  {
    title: 'Activity Logs',
    is_heading: false,
    is_active: false,
    link: {
      name: 'admin.activity-logs'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-history',
    active_icon: 'fad fa-history'
  },
  {
    title: 'Item Claims',
    is_heading: false,
    is_active: false,
    link: {
      name: 'admin.lf-item-claims'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-hand-holding',
    active_icon: 'fad fa-hand-holding'
  }
]

export default MAdmin
